import React, { Component, useState } from 'react';
import PropTypes from 'prop-types';
import { Form, Input, Button, Switch, Col, Row, InputNumber } from 'antd';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';
import {
	createSpecimensItems,
	updateSpecimensItems,
} from 'services/settings/lookup_table/specimens';
import { deactivateItem } from 'services/settings/status';
import showDeactivationModal from 'shared_components/deactivation_modal';

const specimensForm = ({ buttonNames, selecetedData, onDrawerClose, onSuccessCreate, onSuccessUpdate, maxSpecimenSort }) => {
	const [form] = Form.useForm();
	const [isForceDeactivate, setIsForceDeactivate] = useState(false);
	console.log('selectedData =>', selecetedData);

	const onFinish = async values => {
		const payload = {
			active: values.active === true ? 1 : 0,
			specimenName: values.specimenName ? values.specimenName.toUpperCase() : '',
			// For UPDATE: keep existing sort, For CREATE: use maxSpecimenSort + 1
			specimenSort: selecetedData ? selecetedData.specimenSort : (maxSpecimenSort ? maxSpecimenSort + 1 : 1),
		};
		console.log("🚀 ~ onFinish ~ payload:", payload)

		if (buttonNames === 'ADD') {
			const created = await createSpecimensItems(payload);
			if (created) {
				onSuccessCreate();
			}
		} else {
			if (values.active === false && isForceDeactivate) {
				await deactivateItem('Specimen', selecetedData.specimenID);
			}

			payload.specimenID = selecetedData.specimenID;
			const updated = await updateSpecimensItems(payload);
			if (updated) {
				onSuccessUpdate();
			}
		}
	};

	return (
		<div>
			<Form
				form={form}
				layout="vertical"
				onFinish={onFinish}
				initialValues={{
					specimenName: selecetedData ? selecetedData.specimenName : null,
					specimenSort: selecetedData ? selecetedData.specimenSort : null,
					active: selecetedData ? (selecetedData.isActive === 1 ? true : false) : true,
				}}
			>
				<Row>
					<Col span={4}>
						<Form.Item>
							<label>ACTIVE:</label>
						</Form.Item>
					</Col>

					<Col span={6}>
						<Form.Item name="active" valuePropName="checked">
							<Switch 
								disabled={buttonNames === 'ADD'} 
								onChange={checked => {
									if (!checked) {
										showDeactivationModal('Specimen', selecetedData.specimenID, {
											itemLabel: 'Specimen',
											onConfirm: isForce => {
												form.setFieldsValue({ active: false });
												setIsForceDeactivate(isForce);
											},
											onCancel: () => {
												form.setFieldsValue({ active: true });
												setIsForceDeactivate(false);
											},
										});
									} else {
										setIsForceDeactivate(false);
									}
								}}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Form.Item
					label="SPECIMEN NAME"
					name="specimenName"
					rules={[{ required: true, message: 'This field is required' }]}
				>
					<Input maxLength={254} style={{ textTransform: 'uppercase' }} />
				</Form.Item>
				<section className="drawerFooter">
					<Button shape="round" onClick={onDrawerClose} style={{ marginRight: 8, width: 120 }}>
						CANCEL
					</Button>
					<Button type="primary" shape="round" style={{ margin: 10, width: 120 }} htmlType="submit">
						{buttonNames}
					</Button>
				</section>
			</Form>
		</div>
	);
};

export default specimensForm;
